/*
 * Copyright (c) 2025. Bolmate B.V.
 */

import {
    BuyBoxNotificationSettingsImpl,
    NotificationTypeParam,
    Rating,
    ReviewNotificationSettingsImpl,
    StockNotificationSettingsImpl
} from './types';

import {BuyBoxEvent, NotificationType} from './enums';

export const NotificationTypeParams: Record<NotificationType, NotificationTypeParam> = {
    [NotificationType.REVIEWS]: {
        icon: 'star',
        title: 'Review notificatie',
        description: 'Ontvang een e-mail bij nieuwe reviews'
    },
    [NotificationType.PRODUCT_HIJACK]: {
        icon: 'user-shield',
        title: 'Productkaping notificatie',
        description: 'Ontvang een e-mail wanneer een nieuwe verkoper op jouw product verschijnt'
    },
    [NotificationType.BUY_BOX]: {
        icon: 'trophy',
        title: 'Koopblok notificatie',
        description: 'Ontvang een e-mail wanneer het koopblok verandert'
    },
    [NotificationType.STOCK]: {
        icon: 'box-open',
        title: 'Voorraad notificatie',
        description: 'Ontvang een e-mail als de voorraad bijna op is'
    },
    [NotificationType.ORDER]: {
        icon: 'truck-fast',
        title: 'Order notificatie',
        description: 'Ontvang een e-mail bij nieuwe orders'
    }
};

export class ReviewNotificationSettings implements ReviewNotificationSettingsImpl {
    eans: Set<string>;
    ratings: Set<Rating>;

    constructor(data?: {eans?: Set<string> | Array<string> | null; ratings?: Set<Rating> | Array<Rating> | null}) {
        this.eans = new Set(data?.eans);
        this.ratings = new Set(data?.ratings);
    }

    dump = (): Record<string, any> => ({
        eans: this.eans?.size ? Array.from(this.eans) : ['all'],
        ratings: this.ratings?.size ? Array.from(this.ratings) : null
    });
}

export class BuyBoxNotificationSettings implements BuyBoxNotificationSettingsImpl {
    eans: Set<string>;
    buy_box_events: Set<BuyBoxEvent>;

    constructor(data?: {eans?: Set<string> | Array<string> | null; buy_box_events?: Iterable<BuyBoxEvent>}) {
        this.eans = new Set(data?.eans);
        this.buy_box_events = new Set(data?.buy_box_events);
    }

    dump = (): Record<string, any> => ({
        eans: this.eans.size ? Array.from(this.eans) : ['all'],
        buy_box_events: this.buy_box_events.size ? Array.from(this.buy_box_events) : null
    });
}

export class StockNotificationSettings implements StockNotificationSettingsImpl {
    eans: Set<string>;
    threshold: number;

    constructor(data?: {eans?: Iterable<string> | null; threshold?: number}) {
        this.eans = new Set(data?.eans);
        this.threshold = Number(data?.threshold ?? 10);
    }

    dump = (): Record<string, any> => ({
        eans: this.eans.size ? Array.from(this.eans) : ['all'],
        threshold: this.threshold
    });
}
